import React, { useEffect, useRef } from "react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CarouselModal = ({ images, modalOpen, setPostCarouselModal }) => {
    const modal = useRef(null);

    // Close on click outside
    useEffect(() => {
        const clickHandler = (event) => {
            if (!modalOpen) return;
            if (modal.current && !modal.current.contains(event.target)) {
                setPostCarouselModal(false);
            }
        };
        document.addEventListener("mousedown", clickHandler);
        return () => document.removeEventListener("mousedown", clickHandler);
    }, [modalOpen, setPostCarouselModal]);

    // Close on Escape
    useEffect(() => {
        const keyHandler = (event) => {
            if (event.key === "Escape" && modalOpen) {
                setPostCarouselModal(false);
            }
        };
        document.addEventListener("keydown", keyHandler);
        return () => document.removeEventListener("keydown", keyHandler);
    }, [modalOpen, setPostCarouselModal]);

    if (!modalOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center px-4 py-5">
            <div
                ref={modal}
                className="relative w-[80%] max-w-5xl rounded-lg bg-white px-8 py-12 text-center dark:bg-boxdark"
            >
                {/* Close Button */}
                <button
                    onClick={() => setPostCarouselModal(false)}
                    className="absolute right-4 top-4 text-2xl font-semibold text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white transition"
                    aria-label="Close"
                >
                    &times;
                </button>

                {/* Swiper Carousel */}
                <div className="p-4 sm:p-6">
                    <Swiper
                        className="carouselThree"
                        modules={[Navigation, Pagination, Autoplay]}
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 4500,
                            disableOnInteraction: false,
                        }}
                        navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        }}
                    >
                        {images && images.length > 0 ? (
                            images.map((image, index) => (
                                <SwiperSlide key={image}>
                                    <div className="flex items-center justify-center w-full h-full">
                                        <img
                                            src={image?.url || image}
                                      
                                            alt={`User Image ${index + 1}`}
                                            className="max-w-full max-h-[500px] w-auto h-auto rounded"
                                        />
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <SwiperSlide>
                                <div className="flex justify-center items-center h-full">
                                    <p className="text-center text-gray-500">
                                        No images available.
                                    </p>
                                </div>
                            </SwiperSlide>
                        )}

                        {/* Swiper Nav Buttons */}
                        <div className="swiper-button-prev">
                            <svg
                                className="fill-current"
                                width="12"
                                height="20"
                                viewBox="0 0 12 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M10.23 19.49a1 1 0 0 1-.6-.26L1.16 10.6a1 1 0 0 1 0-1.2L9.63.77a1 1 0 0 1 1.41 1.41L2.96 10l8.92 8.03a1 1 0 0 1-.65 1.46z" />
                            </svg>
                        </div>
                        <div className="swiper-button-next">
                            <svg
                                className="fill-current"
                                width="12"
                                height="20"
                                viewBox="0 0 12 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M1.76 19.49a1 1 0 0 1-.6-1.46L9.03 10 .77 1.97A1 1 0 1 1 2.36.77l8.47 8.63a1 1 0 0 1 0 1.2l-8.47 8.63a1 1 0 0 1-.6.26z" />
                            </svg>
                        </div>
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default CarouselModal;
